import { html } from '@lukekaalim/act-web';

import { ConciergeOverlay, createRoomSessionClient, RoomSessionChannel } from "@kosmod/concierge";
import { conciergeApiDef } from "@kosmod/concierge";

import { Channel, Http, RTC, WebSocket } from "@kosmod/pancake";
import { Theatre, useTheatreCoreResource, SceneSessionChannel } from "@kosmod/theatre";

import { useRemoteTheatreController } from "@kosmod/theatre";
import { Component, h, useEffect, useMemo, useRef, useState } from "@lukekaalim/act";
import { ID, useLogger } from '@kosmod/kit';
import { Player, UserState } from '@kosmod/sesame';
import { useConciergeState } from '@kosmod/concierge';

export type TabletopDemoProps = {
  httpClient: Http.Client,
  wsClient: WebSocket.Client,
  rtcClient: RTC.Client,

  apiHost: string,

  self: Player,
}

export const TabletopDemoAPI = Http.api.Root({
  '/': conciergeApiDef
})

/**
 * State-of-the-art Tabletop integration
 */
export const TabletopDemo: Component<TabletopDemoProps> = ({ httpClient, wsClient, rtcClient, apiHost, self }) => {
  return null;
  // const res = useTheatreCoreResource();
  // if (!res)
  //   return 'Loading';

  // const logger = useLogger();

  // const client = useMemo(() => Http.api.createClient(TabletopDemoAPI, apiHost, {
  //   http: httpClient,
  //   websocket: wsClient,
  // }), [httpClient, wsClient, apiHost]);

  // const [port, setPort] = useState<Channel.Port.Client<RoomSessionChannel> | null>(null);
  
  // useEffect(() => {
  //   const connection = client["/"]['room/join'].connect({ playerId: self.id });

  //   setPort(connection.port);

  //   logger.log('Making Connection')

  //   return () => {
  //     connection.disconnect();
  //   }
  // }, [client]);

  // if (!port)
  //   return 'Connecting';

  // const roomClient = useRef(() => createRoomSessionClient(self, port, logger)).get();
  
  // const concierge = useConciergeState(roomClient, self);
  // const [controller, data] = useRemoteTheatreController(roomClient.scene, self);

  // return h(html.div, {
  //   style: { width: '100vw', height: '100vh' }
  // }, [
  //   h(Theatre, { res, controller, data, concierge }),
  //   h(ConciergeOverlay, { state: concierge, user: playerUser, port, rtcClient }),
  // ]);
}


// const playerUser: UserState = { type: 'player', player: {
//   id: ID('player'),
//   name: 'luke'
// }, account: {
//   username: 'lkaalim',
//   password: ID('password'),
//   id: ID('account'),
//   email: 'luke@email',
//   games: []
// } };